<template>
    <div class="body">
        <div class="data-box">
            <div class="modify-box">
                <el-button class="modify-button" type="primary" @click="handleAdd"
                           v-if="allowAction.indexOf('create') != -1">新建字段</el-button>
            </div>
            <div class="list-box">
                <el-table
                        :data="list"
                        stripe
                        style="width: 100%"
                        height="100%"
                >
                    <el-table-column
                            label="字段排序"
                            prop="seq"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            label="字段名称"
                            prop="name"
                            align="center"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            label="类型"
                            prop="type"
                            :formatter="formatType"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            label="字段说明"
                            prop="note"
                            align="center"
                            min-width="200">
                    </el-table-column>
                    <el-table-column
                            label="添加搜索条件(最多选择八个)"
                            align="center"
                            width="120">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.searchable" @change="handleSearchAble(scope.row)"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center"
                            fixed="right"
                            width="200"
                            v-if="optionStatus"
                    >
                        <template slot-scope="scope">
                            <div class="flex-middle flex-center">
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-if="allowAction.indexOf('edit') != -1"
                                        :disabled="scope.row.seq === 0 "
                                        @click="handleMoveUp(scope.row.id)"
                                >上移</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-if="allowAction.indexOf('edit') != -1"
                                        :disabled="scope.row.seq === list.length-1"
                                        @click="handleMoveDown(scope.row.id)"
                                >下移</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        :disabled="scope.row.seq === 0"
                                        @click="handleMoveTop(scope.row.id)"
                                        v-if="allowAction.indexOf('edit') != -1"
                                >置顶</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        v-if="allowAction.indexOf('edit') != -1"
                                >编辑</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        @click="handleDelete(scope.row)"
                                        v-if="allowAction.indexOf('delete') != -1"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <AddFormDialog v-on:fetchData="fetchData" ref="AddFormDialog"></AddFormDialog>
    </div>
</template>

<script>
    import AddFormDialog from './components/AddFormDialog'
    import Utils from "../../assets/js/Utils";

    export default {
        name: 'FormManage',
        components: {AddFormDialog},
        data() {
            return {
                allowAction: [],
                optionStatus: true,
                list: [],

                showSearch: [],
            }
        },
        mounted(){
            this.fetchData()
            this.allowAction = Utils.checkMenuOprate('enroll.form')
            for(let i = 0;i<this.allowAction.length; i++) {
                let item = this.allowAction[i]
                if(item != 'view' && item != 'create') {
                    this.optionStatus = true
                    return
                }
            }
            this.optionStatus = false
        },
        methods: {

            formatType(val) {
                switch (val.type) {
                    case 1:return '文本'
                    case 2:return '选项'
                    case 3:return '身份证'
                    case 4:return '数字'
                    case 5:return '电话'
                    case 6:return '图片'
                    case 7:return '文件'
                    default: return '无'
                }
            },

            handleSearch() {
                this.fetchData()
            },

            fetchData() {
                let params = {
                    pageSize: 1000,
                    pageNum: 1,
                }
                axios.get(Urls.URL.form_url,{params}).then(res => {
                    if(res.status == '200') {
                        this.list = res.data.data.rows
                        this.list.forEach((item,index) => {
                            this.list[index].searchable = item.searchable == 1?true:false
                        })
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleAdd() {
                this.$refs.AddFormDialog && this.$refs.AddFormDialog.setMaskVisible(true, {});
            },

            handleSearchAble(data) {
                let url = Urls.URL.form_url+'/'+data.id
                if(data.searchable) {
                    url = url + '/searchable/enable'
                }else {
                    url = url + '/searchable/disable'
                }
                axios.post(url).then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleMoveUp(id) {
                axios.post(Urls.URL.form_url+'/'+id+'/up').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleMoveDown(id) {
                axios.post(Urls.URL.form_url+'/'+id+'/down').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleMoveTop(id) {
                axios.post(Urls.URL.form_url+'/'+id+'/top').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleEdit(data) {
                this.$refs.AddFormDialog && this.$refs.AddFormDialog.setMaskVisible(true, data);
            },

            handleDelete(data) {
                this.$confirm(`表单项“${data.name}”正在被删除，是否确定`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.delete(Urls.URL.form_url+'/'+data.id).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                }).catch(() => {
                    return
                });

            },

        }
    }
</script>

<style scoped lang="stylus">
    *
        box-sizing border-box
    .body {
        width 100%
        height 100%
        padding-top 20px
    }

    .data-box {
        height 100%
        background-color white
        .modify-box {
            flex 1
            padding 10px 20px
            display flex
            align-items center
            .modify-button {
                width 100px
            }
        }
        .list-box {
            padding 0 25px
            height 90%
            .modify-box {
                display flex
            }
        }
    }


</style>